import { render, staticRenderFns } from "./StockPlaceProductForm.vue?vue&type=template&id=0f3e1c7b&"
import script from "./StockPlaceProductForm.vue?vue&type=script&lang=js&"
export * from "./StockPlaceProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports